import { MdDataExploration } from "react-icons/md";

export const howItWorks = () => {
  const data = [
    {
      id: 0,
      url: require("../assets/collective-page/iconPortfolio.svg"),
      title: "Online",
      title2: "whisky session",
      text: "Sign up for an online whisky tasting session for just £20.",
    },
    {
      id: 1,
      url: require("../assets/collective-page/iconShipping.svg"),
      title: "Receive",
      title2: "tasting pack",
      text: `We’ll send you our Whisky Tasting Pack featuring
      5 x 30ml bottles of the nest single cask whisky.`,
    },
    {
      id: 2,
      url: require("../assets/collective-page/iconBarrel.svg"),
      title: "tasting",
      title2: "experience",
      text: `Once we’ve dispatched your whisky, we’ll email you to
      arrange a date and time to suit your diary, then join us
      for the ultimate whisky tasting experience.`,
    },
    {
      id: 3,
      url: require("../assets/collective-page/iconBarrel.svg"),
      title: "Ultimate",
      title2: "whisky experience",
      text: "We’ll show you why single cask is the ultimate whisky experience.",
    },
    {
      id: 4,
      url: require("../assets/collective-page/iconPortfolio.svg"),
      title: "unique",
      title2: "story",
      text: "Then we’ll taste those wonderful drams and tell you the unique story of each one.",
    },
  ];
  return data;
};
